import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TimelineMax } from 'gsap'

import SlideHOC from '../SlideHOC'
import ANIMATION_TYPES from '../../../../constants/animationTypes'

import tipIcon from '../../assets/tipIcon.svg'
import './SlideScene.scss'

const BOUNCE_PERCENT = 1

class SlideScene extends Component {

  defineAnimations () {
    this.inAnimation = new TimelineMax({ paused: true })
      .fromTo(this.bgRef, 0.05, { xPercent: 0, autoAlpha: 0 }, { xPercent: 100, autoAlpha: 1 })
      .to(this.rootRef, 0, { autoAlpha: 1, zIndex: 10, xPercent: 0, immediateRender: false })
      .to(this.wrapperRef, 0, { xPercent: 0, rotationY: 0, immediateRender: false })
      .fromTo(this.bgRef, this.props.duration,
        { xPercent: 100 }, { xPercent: -BOUNCE_PERCENT, delay: this.props.duration * 0.05 })
      .fromTo(this.bgRef, this.props.duration * 0.2,
        { xPercent: -BOUNCE_PERCENT }, { xPercent: BOUNCE_PERCENT })
      .to(this.bgRef, this.props.duration * 0.2, { xPercent: 0 })
      .fromTo(this.contentRef, this.props.duration * 0.5,
        { xPercent: 150, autoAlpha: 0 }, { autoAlpha: 1, xPercent: -3, delay: this.props.duration * 0.5, immediateRender: false }, 0)
      .fromTo(this.contentRef, this.props.duration * 0.5,
        { xPercent: -3 }, { xPercent: 1.5, delay: this.props.duration * 0.5 * 2 }, 0)
      .to(this.contentRef, this.props.duration * 0.5,
        { xPercent: 0, delay: this.props.duration * 0.5 * 3 }, 0)

    this.inReversedAnimation = new TimelineMax({ paused: true })
      .to(this.contentRef, 0, { autoAlpha: 0 })
      .fromTo(this.bgRef, 0.05, { xPercent: 0, autoAlpha: 0 }, { xPercent: -100, autoAlpha: 1 })
      .to(this.rootRef, 0, { autoAlpha: 1, zIndex: 10, xPercent: 0, immediateRender: false })
      .to(this.wrapperRef, 0, { xPercent: 0, rotationY: 0, immediateRender: false })
      .fromTo(this.bgRef, this.props.duration,
        { xPercent: -100 }, { xPercent: BOUNCE_PERCENT, delay: this.props.duration * 0.05 })
      .fromTo(this.bgRef, this.props.duration * 0.2,
        { xPercent: BOUNCE_PERCENT }, { xPercent: -BOUNCE_PERCENT })
      .to(this.bgRef, this.props.duration * 0.2, { xPercent: 0 })
      .fromTo(this.contentRef, this.props.duration * 0.5,
        { xPercent: -150, autoAlpha: 0 }, { autoAlpha: 1, xPercent: 3, delay: this.props.duration * 0.5, immediateRender: false }, 0)
      .fromTo(this.contentRef, this.props.duration * 0.5,
        { xPercent: 3 }, { xPercent: -1.5, delay: this.props.duration * 0.5 * 2 }, 0)
      .to(this.contentRef, this.props.duration * 0.5,
        { xPercent: 0, delay: this.props.duration * 0.5 * 3 }, 0)

    this.outAnimation = new TimelineMax({ paused: true })
      .to(this.rootRef, 0, { zIndex: 1 }, 0)
      .fromTo(this.rootRef, this.props.duration,
        { xPercent: 0, autoAlpha: 1, immediateRender: false }, { autoAlpha: 0 })
      .fromTo(this.wrapperRef, this.props.duration,
        { rotationY: 0, xPercent: 0 }, { xPercent: 0, rotationY: 100, transformOrigin: 'left' }, 0)

    this.outReversedAnimation = new TimelineMax({ paused: true })
      .to(this.rootRef, 0, { zIndex: 1 }, 0)
      .fromTo(this.rootRef, this.props.duration,
        { zIndex: 1, xPercent: 0, autoAlpha: 1, immediateRender: false }, { xPercent: 0, autoAlpha: 0 })
      .fromTo(this.wrapperRef, this.props.duration,
        { rotationY: 0, xPercent: 0 }, { xPercent: 0, rotationY: -100, transformOrigin: 'right' }, 0)
  }

  render () {
    // console.log('SlideScene render')
    const { bg, slideNum, title, description, tip, subtitle } = this.props
    return (
      <div className='bo_slide' ref={ref => (this.rootRef = ref)}>
        <div className='bo_slide__wrapper' ref={ref => (this.wrapperRef = ref)}>
          <div
            id={`bo_slide__bg_${slideNum}`}
            className={`bo_slide__bg bo_slide__bg_${slideNum}`}
            style={{ backgroundImage: `url(${bg})` }}
            ref={ref => (this.bgRef = ref)}
          />

          <div className='bo_slide__content' ref={ref => (this.contentRef = ref)}>
            <div id={`bo_slide__subtitle_${slideNum}`} className={`bo_slide__subtitle bo_slide__subtitle_${slideNum}`}>
              <span className={`bo_slide__subtitle--text bo_slide__subtitle_${slideNum}--text`}>{ subtitle }</span>
            </div>
            <div id={`bo_slide__title_${slideNum}`} className={`bo_slide__title bo_slide__title_${slideNum}`}>
              <span className={`bo_slide__title--text bo_slide__title_${slideNum}--text`}>{ title }</span>
            </div>
            <div id={`bo_slide__desc_${slideNum}`} className={`bo_slide__description bo_slide__desc_${slideNum}`}>
              <span className={`bo_slide__description--text bo_slide__desc_${slideNum}--text`}>{ description }</span>
            </div>
            <div id={`bo_slide__tip_${slideNum}`} className={`bo_slide__tip bo_slide__tip_${slideNum}`} ref={ref => (this.tipRef = ref)}>
              <div className='bo_slide__tip-icon' style={{ backgroundImage: `url(${tipIcon})` }} />
              <div>{ tip }</div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  static defaultProps = {
    animation: ANIMATION_TYPES.NONE,
    duration: 0.5
  }

  static propTypes = {
    subtitle: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    tip: PropTypes.string,
    bg: PropTypes.string,
    animation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]), // eslint-disable-line react/no-unused-prop-types
    duration: PropTypes.number,
    slideNum: PropTypes.number
  }
}

export default SlideHOC(SlideScene)



// WEBPACK FOOTER //
// ./src/templates/bouncy/components/slide/SlideScene.js